export async function getHighSchoolProfile(apiInstance) {
  try {
    const response = await apiInstance.get(`/HighSchool/profile`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}
